import React from 'react';
import PropTypes from 'prop-types';

import FlatButton from 'material-ui/FlatButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';

import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import HomeIcon from 'material-ui/svg-icons/action/home';
import AddIcon from 'material-ui/svg-icons/action/note-add';
import CompletedIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import OpenInNewIcon from 'material-ui/svg-icons/action/open-in-new';

class Menu extends React.Component {
    goto = (path) => {
        return () => {
            this.props.router.push(path);
        };
    }

    render() {
        const { viewer } = this.props;
        return (
            <nav style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}>
                <FlatButton label="Oversikt" icon={<HomeIcon/>} onClick={this.goto('/')}/>
                <IconMenu iconButtonElement={<IconButton><MoreVertIcon/></IconButton>}>
                    {viewer.canAdd && (
                        <MenuItem primaryText="Nytt forslag" onClick={this.goto('/edit')} leftIcon={<AddIcon/>} />
                    )}
                    <MenuItem primaryText="Fullførte forslag" onClick={this.goto('/completed')} leftIcon={<CompletedIcon/>} />
                    <MenuItem primaryText="Prosjektportal" href="https://studntnu.sharepoint.com/sites/it-prosjektportal/SitePages/Home.aspx" leftIcon={<OpenInNewIcon/>} />

                </IconMenu>
            </nav>
        );
    }
}

Menu.propTypes = {
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js